import type { PurchasingVendorItemPackRequest } from '@/services/purchasing'

export type PackEditorFields = {
  packText: string
  packCount: string
  unitSizeQty: string
  unitSizeUom: string
}

/** Build pack API payload: non-empty pack_text wins; else structured fields (all three required). */
export function buildPurchasingVendorItemPackRequest(
  fields: PackEditorFields,
): PurchasingVendorItemPackRequest | null {
  const trimmedText = fields.packText.trim()
  if (trimmedText) {
    return { pack_text: trimmedText }
  }

  const packCount = fields.packCount.trim()
  const unitSizeQty = fields.unitSizeQty.trim()
  const unitSizeUom = fields.unitSizeUom.trim()
  const hasStructured = packCount || unitSizeQty || unitSizeUom
  if (!hasStructured) {
    return null
  }
  if (!packCount || !unitSizeQty || !unitSizeUom) {
    return null
  }
  return {
    pack_count: packCount,
    unit_size_qty: unitSizeQty,
    unit_size_uom: unitSizeUom,
  }
}
